import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoadingStateProps {
  label?: string;
  size?: "sm" | "md" | "lg";
  inline?: boolean;
  className?: string;
}

const SIZE = {
  sm: { icon: 16, py: "py-4" },
  md: { icon: 24, py: "py-12" },
  lg: { icon: 32, py: "py-20" },
};

export function LoadingState({
  label = "Chargement…",
  size = "md",
  inline = false,
  className,
}: LoadingStateProps) {
  const s = SIZE[size];
  if (inline) {
    return (
      <span className={cn("inline-flex items-center gap-2 text-gray-400", className)}>
        <Loader2 size={s.icon} className="animate-spin" />
        <span className="text-[10px] font-black uppercase tracking-widest">{label}</span>
      </span>
    );
  }
  return (
    <div className={cn("flex flex-col items-center justify-center gap-3", s.py, className)}>
      <Loader2 size={s.icon} className="animate-spin text-indigo-600" />
      <span className="text-[10px] font-black uppercase tracking-widest text-gray-400">
        {label}
      </span>
    </div>
  );
}
